if (!customElements.get('led-cct-preview')) {
 customElements.define('led-cct-preview', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const button = this.querySelector('button');
   const slider = this.querySelector('input');
   const output = this.querySelector('output');
   const hint = this.querySelector('.led-cct-hint');
   const source = this.querySelector('img');
   const canvas = this.querySelector('canvas');
   let mask;
   const paint = () => {
    if (!mask) return;
    const k = Number(slider.value);
    const stops = k <= 4000 ? [[255,195,104],[255,239,211],(k-2700)/1300] : [[255,239,211],[222,239,255],(k-4000)/2000];
    const rgb = stops[0].map((n,i) => Math.round(n+(stops[1][i]-n)*stops[2]));
    const color = `rgb(${rgb.join(',')})`;
    const tinted = document.createElement('canvas');
    tinted.width = mask.width; tinted.height = mask.height;
    const tint = tinted.getContext('2d');
    tint.drawImage(mask,0,0);
    tint.globalCompositeOperation = 'source-in';
    tint.fillStyle = color; tint.fillRect(0,0,mask.width,mask.height);
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0,0,canvas.width,canvas.height);
    // Glow is local to the yellow LED emitters; never tint the PCB or its edges.
    ctx.shadowColor = color; ctx.shadowBlur = 10;
    ctx.filter = 'blur(1.2px)';
    ctx.drawImage(tinted,0,0);
    ctx.filter = 'none';
    ctx.drawImage(tinted,0,0);
    ctx.shadowBlur = 0;
    ctx.globalAlpha = .45;
    ctx.drawImage(mask,0,0);
    ctx.globalAlpha = 1;
   };
   const buildMask = () => {
    if (mask || !source.naturalWidth) return;
    try {
     const w = source.naturalWidth, h = source.naturalHeight;
     const scan = document.createElement('canvas'); scan.width=w; scan.height=h;
     const ctx=scan.getContext('2d',{willReadFrequently:true}); ctx.drawImage(source,0,0);
     const pixels=ctx.getImageData(0,0,w,h).data;
     const selected=new Uint8Array(w*h);
     for(let p=0;p<selected.length;p++) {
      const r=pixels[p*4],g=pixels[p*4+1],b=pixels[p*4+2];
      // Yellow phosphor only: exclude white PCB, gray markings and reddish copper pads.
      selected[p]=r>145 && g>125 && g>r*.74 && r>=g*.98 && b<g*.72 ? 1:0;
     }
     const out=ctx.createImageData(w,h);
     let count=0;
     for(let p=0;p<selected.length;p++) {
      if(!selected[p]) continue;
      const component=[p]; selected[p]=0;
      let minX=p%w,maxX=minX,minY=Math.floor(p/w),maxY=minY;
      for(let n=0;n<component.length;n++) {
       const q=component[n],x=q%w,y=Math.floor(q/w);
       minX=Math.min(minX,x);maxX=Math.max(maxX,x);minY=Math.min(minY,y);maxY=Math.max(maxY,y);
       for(const [dx,dy] of [[-1,0],[1,0],[0,-1],[0,1]]) {
        const nx=x+dx,ny=y+dy,j=ny*w+nx;
        if(nx>=0&&nx<w&&ny>=0&&ny<h&&selected[j]) {selected[j]=0;component.push(j);}
       }
      }
      if(component.length<2 || component.length>120 || maxX-minX>18 || maxY-minY>18) continue;
      count++;
      for(const q of component) {out.data[q*4]=255;out.data[q*4+1]=255;out.data[q*4+2]=255;out.data[q*4+3]=255;}
     }
     mask=document.createElement('canvas');mask.width=w;mask.height=h;mask.getContext('2d').putImageData(out,0,0);
     canvas.width=w;canvas.height=h;
     this.dataset.emitterCount=String(count);
     paint();
    } catch(error) {
     // Keep the accurate unmodified photograph if cross-origin pixel access is unavailable.
     this.dataset.previewUnavailable='true';
     if (hint) hint.textContent='Lighting preview unavailable';
    }
   };
   let pinned = false;
   const light = on => {
    this.classList.toggle('is-lit', on);
    button.setAttribute('aria-pressed', String(on));
    if (hint) hint.textContent = on ? 'Lights on · Tap to switch off' : 'Hover or tap to illuminate';
   };
   const update = () => {
    const k = Number(slider.value);
    paint();
    output.textContent = `${k} K`;
    slider.setAttribute('aria-valuetext', `${k} kelvin`);
   };
   update();
   source.addEventListener('load',buildMask,{once:true});
   if(source.complete) buildMask();
   slider.addEventListener('input', () => { update(); pinned = true; light(true); });
   button.addEventListener('click', () => { pinned = !pinned; light(pinned); });
   button.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') light(true); });
   button.addEventListener('pointerleave', () => light(pinned));
  }
 });
}
